import React, { useEffect, useRef, useState, useContext } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import { toNumber } from 'lodash';

import DashboardContext from '../../home/DashboardContext';
import { DASHBOARD_CARD_STYLE } from '../../constants';

const useStyles = makeStyles(() => ({
  wrap: {
    flex: '1 1 0',
    minWidth: 0,
    minHeight: 0,
    height: '100%',
    boxSizing: 'border-box',
    ...DASHBOARD_CARD_STYLE,
    overflow: 'hidden',
    display: 'flex',
  },
  host: {
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    width: '100%',
    height: '100%',
  },
}));

const Chart = ({ filter, id, width }) => {
  const {
    data: { currentPharmacyId },
  } = useSelector((state) => state.auth.user);
  const classes = useStyles();
  const { sdk } = useContext(DashboardContext);
  const chartDiv = useRef(null);
  const [rendered, setRendered] = useState(false);
  const [chart, setChart] = useState(null);
  const flexGrow = Math.max(1, toNumber(width) || 1);

  useEffect(() => {
    if (!sdk) return;
    setRendered(false);
    setChart(sdk.createChart({ chartId: id, autoRefresh: true }));
  }, [sdk, id]);

  useEffect(() => {
    if (!chart) return undefined;
    let cancelled = false;
    chart
      .render(chartDiv.current)
      .then(() => {
        if (!cancelled) setRendered(true);
      })
      .catch((err) => console.log('Error during Charts rendering.', err));
    return () => {
      cancelled = true;
    };
  }, [chart]);

  useEffect(() => {
    const _filter = { [filter[0]]: currentPharmacyId };
    if (rendered) {
      chart.setFilter(_filter).catch((err) => console.log('Error while filtering.', err));
    }
  }, [chart, filter, rendered, currentPharmacyId]);

  return (
    <div className={classes.wrap} style={{ flexGrow }}>
      <div className={classes.host} ref={chartDiv} />
    </div>
  );
};

export default Chart;
